import { createEntity } from 'lib/resource';
import ShowUser from './schema';

export default createEntity(ShowUser);
